import { type EmojiId, type ResourceId } from '../common/structs';

export const yatPage = () => ({
    protected: () => ({
        item: (itemId?: ResourceId) => `/v2/yat_page/items${itemId ? `/${itemId}` : ''}`,
        pageCollectionItems: (pageId: string) => `/v2/yat_page/${pageId}/items/search`,
        pageItems: (pageId: string) => `/v2/yat_page/${pageId}/items`,
        pageItemsBulk: (pageId: string) => `/v2/yat_page/${pageId}/items/change`,
        convert: (eid: EmojiId) => `/v2/yat_page/${eid}/convert`,
        page: (eid: EmojiId) => `/v2/yat_page/${eid}`,
        pageItem: () => `/v2/yat_page/items`,
        search: () => `/v2/yat_page/items/search`,
        upsert: () => `/v2/yat_page`,
        discard: (pageId: string) => `/v2/yat_page/${pageId}/items/discard`,
    }),
    public: (eid: EmojiId) => ({
        // Note that this endpoint handles fetching page details for both Yat Page v1 and v2.
        // This means that v1 returns the Tags, while v2 returns Yat Page details (like publish date, etc.)
        page: () => `/v2/yat_page/${eid}/version`,
        pageItems: () => `/v2/yat_page_public/${eid}/items`,
        search: () => `/v2/yat_page_public/${eid}/items/search`,
    }),
});
